import { useSidebar } from "@/components/shadcn/sidebar.tsx";
import {Icon} from "@/components/Icon.tsx";
import React from "react";

export const SidebarButton = ({
  children,
  icon,
  imageUrl,
}: {
  children: any;
  icon: string;
  imageUrl: string | null;
}) => {
  const sidebarCtx = useSidebar();

  return (
    <div
      className={
        "w-full flex items-center justify-between text-sm cursor-pointer transition-all duration-150 " +
        (sidebarCtx.open
          ? "p-1 border rounded-md shadow bg-white hover:bg-black-200"
          : "")
      }
    >
      <div className="flex items-center gap-2">
        {imageUrl ? (
          <img src={imageUrl} alt="avatar" className="w-8 rounded-full" />
        ) : (
          <Icon icon={icon} height={32} width={32} className="w-8" />
        )}
        <div className="flex-1 max-w-[185px]">
          {sidebarCtx.open && children}
        </div>
      </div>
    </div>
  );
};
